import { render } from "./PartnerCard.vue?vue&type=template&id=37f28dc2&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=js"
export * from "./PartnerCard.vue?vue&type=script&lang=js"

import "./PartnerCard.vue?vue&type=style&index=0&id=37f28dc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f28dc2"]])

export default __exports__